__turbopack_context__.v({
  "bar": "ParTka_bar",
  "container": "ParTka_container",
});
